import * as React from "react"

import { cn } from "@ais-ui/utils"

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      // Disable browser autocomplete by default to prevent unwanted suggestions
      // Individual textareas can override this by passing autoComplete prop explicitly
      autoComplete="off"
      {...props}
    />
  )
})
Textarea.displayName = "Textarea"

export { Textarea }
